/** Cuerpo citado/reenviado cortado (snippet o caché optimista incompleta). */
export function looksLikeTruncatedQuotedBody(html) {
  const plain = String(html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!plain) return false;
  if (plain.includes("Vista previa del índice")) return true;
  if (plain.length > 2500) return false;

  const hasQuoteMarker =
    /mensaje original|mensaje reenviado|forwarded message|original message/i.test(
      plain
    );
  if (!hasQuoteMarker) return false;

  if (
    /Hi Ilker|Hello Gemma|Dear Ilker|fabric|NOTA LEGAL|Muchas gracias|Best regards/i.test(
      plain
    )
  ) {
    return false;
  }

  if (plain.length < 1500) return true;
  if (/Para:.*&(?:amp;)?$/.test(plain)) return true;
  if (/De: "?[A-Za-z0-9._@\s-]{0,50}$/.test(plain)) return true;

  return false;
}
